import { ILandingPlanning } from 'partner360/models/landing/ILandingPlanning'
import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'
import { LandingCategory } from 'partner360/models/landing/LandingCategory'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

interface IGetStatusWithNotEmptyData {
  selectedCategory: LandingCategory
  selectedPlanning: ILandingPlanning
  processedPlannings: ILandingProcessedPlanningFetched[]
  selectedStatus: LandingStatus
}
export const getStatusWithNotEmptyData = ({
  selectedPlanning,
  selectedCategory,
  processedPlannings,
  selectedStatus,
}: IGetStatusWithNotEmptyData) => {
  const categoryData = selectedPlanning.AllCategories.find((el) => el.Category === selectedCategory)
  const offeringsForCategory = categoryData ? categoryData.Offerings.map((el) => el.Offering) : []

  const filtered = processedPlannings.filter((el) => {
    return (
      el.category === selectedCategory &&
      el.planningId === selectedPlanning.PlanningId &&
      offeringsForCategory.includes(el.offering)
    )
  })

  if (filtered.some((el) => el.status === selectedStatus)) {
    return selectedStatus
  }

  if (filtered.length && filtered[0].status) {
    return filtered[0].status
  }

  return LandingStatus.NotCompleted
}
